<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-button @click.native="onShowModal">Create transfer</app-button>
        <app-input
          @input.native="onTransferSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by id"
          name="search"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__select>
          <label
            v-if="table.items.filter(item => item.transport_amount > 0).length"
            class="checkbox checkbox--table"
          >
            <input
              v-model="checked_all"
              type="checkbox"
              name="checked_all"
              ref="mainCh"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #h__employee>
          <div class="table-default__left">Taken by</div>
        </template>
        <template #select="{ row }">
          <label v-if="row.transport_amount > 0" class="checkbox  checkbox--table">
            <input
              v-model="checked"
              type="checkbox"
              :value="row.id"
              :name="row.id"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'product-storage-transfer-detail', params: {id: row.id }}" class="table-default__link-border">
              Transfer - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #products_amount="{ row }">
          {{ row.products_amount ? row.products_amount.toLocaleString() : 0 }} TSh
        </template>
        <template #transport_amount="{ row }">
          <span
            v-tooltip="{content: tooltipContent(row), placement: 'top-start', offset: 10, html: true}"
          >
            {{ row.transport_amount.toLocaleString() }} TSh
          </span>
        </template>
        <template #responsible_center="{ row }">
          {{ row.responsible_center ? row.responsible_center.name : '-' }}
        </template>
        <template #responsible_center_department="{ row }">
          {{ row.responsible_center_department ? row.responsible_center_department.name : '-' }}
        </template>
        <template #employee="{ row }">
          <div v-if="row.employee" class="table-default__left">
            <router-link
                v-if="is_general_manager"
                :to="{name: 'employees-profile', params: {id: row.employee.id }}"
                class="table-default__link-border"
            >
              {{ row.employee.full_name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.employee.full_name }}</div>
          </div>
          <div v-if="row.mountain_crew" class="table-default__left">
<!--            <router-link-->
<!--              v-if="is_general_manager"-->
<!--              :to="{name: 'climbing-mountain-crew-detail', params: {id: row.mountain_crew.id }}"-->
<!--              class="table-default__link-border"-->
<!--            >-->
<!--              {{ row.mountain_crew.full_name }}-->
<!--            </router-link>-->
            <div class="table-default__left">{{ row.mountain_crew.full_name }}</div>
          </div>
          <template v-if="!row.employee && !row.mountain_crew">-</template>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
      <template v-if="table_reverted.items.length">
        <app-cells>
          <h2 class="title">Reverted</h2>
        </app-cells>
        <v-client-table
          :data="table_reverted.items"
          :columns="table_reverted.columns"
          :options="table_reverted.options"
          class="table-default"
          :class="{ 'table-default--loading': table_reverted_preloader }"
        >
          <template #h__id>
            <div class="table-default__left">ID</div>
          </template>
          <template #h__employee>
            <div class="table-default__left">Taken by</div>
          </template>
          <template #id="{ row }">
            <div class="table-default__left">
              <router-link :to="{name: 'product-storage-transfer-detail', params: {id: row.id }}" class="table-default__link-border">
                Transfer - {{ row.id }}
              </router-link>
            </div>
          </template>
          <template #date="{ row }">
            {{ dateFormat(row.date) }}
          </template>
          <template #products_amount="{ row }">
            {{ row.products_amount ? row.products_amount.toLocaleString() : 0 }} TSh
          </template>
          <template #transport_amount="{ row }">
          <span
            v-tooltip="{content: tooltipContent(row), placement: 'top-start', offset: 10, html: true}"
          >
            {{ row.transport_amount.toLocaleString() }} TSh
          </span>
          </template>
          <template #responsible_center="{ row }">
            {{ row.responsible_center ? row.responsible_center.name : '-' }}
          </template>
          <template #responsible_center_department="{ row }">
            {{ row.responsible_center_department ? row.responsible_center_department.name : '-' }}
          </template>
          <template #employee="{ row }">
            <div class="table-default__left">
              <router-link v-if="row.employee" :to="{name: 'employees-profile', params: {id: row.employee.id }}" class="table-default__link-border">
                {{ row.employee.full_name }}
              </router-link>
              <router-link v-if="row.mountain_crew" :to="{name: 'climbing-mountain-crew-detail', params: {id: row.mountain_crew.id }}" class="table-default__link-border">
                {{ row.mountain_crew.full_name }}
              </router-link>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationReverted"
              v-if="pagination_reverted.pages > 1"
              v-model="pagination_reverted.page"
              :page-count="pagination_reverted.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_reverted.count" :count="table_reverted.items.length" :page="pagination_reverted.page" />
        </app-cells>
      </template>
    </template>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected transfers: <span>{{ checked.length }}</span></div>
      <app-button @click.native="onPaymentCreate" ref="submitPayment">Request cash</app-button>
    </div>
    <modal
      name="client-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onCloseModal" class="popup__close" type="button"></button>
        <div class="popup__title">New transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group v-if="!is_product_storage_storekeeper" label="Storekeeper" required>
              <app-select
                v-model="form.storekeeper"
                :options="employee_options"
                :reduce="item => item.id"
                :clearable="false"
                label="full_name"
                placeholder="Storekeeper"
                :error="$v.form.storekeeper.$error"
              />
              <template #error>
                <div v-if="$v.form.storekeeper.$dirty && !$v.form.storekeeper.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Responsible center" required>
              <app-select
                @input="onSelectResponsibleCenter"
                v-model="form.responsible_center"
                :options="responsible_center_options"
                :clearable="false"
                placeholder="Responsible center"
                class="select"
                :error="$v.form.responsible_center.$error"
              />
              <template #error>
                <div v-if="$v.form.responsible_center.$dirty && !$v.form.responsible_center.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Department" required>
              <app-select
                v-model="form.responsible_center_department"
                :options="responsible_center_departments_options"
                :reduce="item => item.code"
                :clearable="false"
                placeholder="Department"
                :readonly="!form.responsible_center"
                :error="$v.form.responsible_center_department.$error"
              />
              <template #error>
                <div v-if="$v.form.responsible_center_department.$dirty && !$v.form.responsible_center_department.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group class="form-group--center">
              <app-cells :indent="false">
                <app-radio
                  @change.native="onChangeTakenByType"
                  v-for="item in taken_by_types"
                  :key="item.code"
                  v-model.number="taken_by_type"
                  :value="item.code"
                  name="taken_by_type"
                  :checked="taken_by_type"
                >
                  <template #label>{{ item.name }}</template>
                </app-radio>
              </app-cells>
            </app-form-group>
            <app-form-group label="Taken by" required>
              <app-select
                v-model="form.some_employee"
                :options="taken_by_type === 'employee' ? employee_type_options : mountain_crew_type_options"
                :clearable="false"
                label="full_name"
                placeholder="Taken by"
                :error="$v.form.some_employee.$error"
              />
              <template #error>
                <div v-if="$v.form.some_employee.$dirty && !$v.form.some_employee.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                v-model="form.note"
                id="notes"
                placeholder="Notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Create transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getClimbingMountainCrewListSearch,
  getEmployeesListSearch,
  getProductStorageResponsibleCenter,
  getProductStorageTransfers,
  postProductStorageCashRequests,
  postProductStorageTransfer,
} from '@/http'
import debounce from 'lodash/debounce'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { format, parse } from 'date-fns'

export default {
  name: 'ProductStorageTransfersActive',
  data() {
    return {
      search: '',
      is_loaded: false,
      table: {
        items: [],
        columns: ['select', 'id', 'date', 'products_amount', 'transport_amount', 'responsible_center', 'responsible_center_department', 'employee'],
        options: {
          headings: {
            'select': '',
            'id': 'ID',
            'date': 'Date',
            'products_amount': 'Est. Value',
            'transport_amount': 'Transport',
            'responsible_center': 'Responsible center',
            'responsible_center_department': 'Department',
            'employee': 'Taken by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false,
        },
      },
      table_reverted: {
        items: [],
        columns: ['id', 'date', 'products_amount', 'transport_amount', 'responsible_center', 'responsible_center_department', 'employee'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'products_amount': 'Est. Value',
            'transport_amount': 'Transport',
            'responsible_center': 'Responsible center',
            'responsible_center_department': 'Department',
            'employee': 'Taken by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_reverted: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {
        storekeeper: null,
        responsible_center_department: null,
      },
      employee_options: [],
      buyer_options: [],
      responsible_center_options: [],
      responsible_center_departments_options: [],
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      table_preloader: false,
      table_reverted_preloader: false,
      taken_by_types: [
        {
          code: 'employee',
          name: 'Employee'
        },
        {
          code: 'mountain_crew',
          name: 'Mountain crew'
        }
      ],
      taken_by_type: 'employee',
      employee_type_options: [],
      mountain_crew_type_options: [],
    }
  },
  validations: {
    form: {
      storekeeper: {
        required: requiredIf(function() {
          return !this.is_product_storage_storekeeper
        })
      },
      some_employee: { required },
      responsible_center: { required },
      responsible_center_department: { required },
    }
  },
  computed: {
    is_product_storage_storekeeper() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_storekeeper')
    },
    is_general_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager')
    }
  },
  created() {
    this.fetchItems()
    this.fetchItemsReverted()
    getProductStorageResponsibleCenter().then(response => { this.responsible_center_options = response.data })
    if (!this.is_product_storage_storekeeper) {
      getEmployeesListSearch({
        position: 'product_keeper',
        employment_status: 'working',
      })
        .then(response => {
          this.employee_options = response.data
          if (response.data.length) this.form.storekeeper = response.data[0].id
        })
    }
    getEmployeesListSearch().then(res => { this.employee_type_options = res.data })
    getClimbingMountainCrewListSearch().then(res => { this.mountain_crew_type_options = res.data })
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table.items.forEach(item => {
          if ((item.transport_amount > 0) && !this.checked.includes(item.id)) this.checked.push(item.id)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  methods: {
    onChangeTakenByType() {
      this.form.some_employee = null
    },
    onSelectResponsibleCenter() {
      this.responsible_center_departments_options = this.form.responsible_center.departments
      if (this.form.responsible_center.departments.length === 1) this.form.responsible_center_department = this.form.responsible_center.departments[0].code
      else this.form.responsible_center_department = null
    },
    onPaymentCreate() {
      this.$refs.submitPayment.preload = true
      postProductStorageCashRequests({ entity: 'transfers', transfers: this.checked })
        .finally(() => { this.$refs.submitPayment.preload = false })
        .then(() => {
          this.checked_all = false
          this.checked = []
          this.fetchItems()
          this.$notify({
            type: 'success',
            title: 'Cash request created. Get the money in the accounting department.',
          })
        })
    },
    tooltipContent(data) {
      if (!data.transport) return ''
      return `${data.transport.name} (${data.transport_qty})`
    },
    onShowModal() {
      this.$modal.show('client-form')
    },
    onCloseModal() {
      this.$modal.hide('client-form')
      this.form = {}
      this.$v.form.$reset()
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onClickPaginationReverted(page) {
      this.table_reverted_preloader = true
      this.pagination_reverted.page = page
      this.fetchItemsReverted()
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    fetchItems() {
      getProductStorageTransfers({
        page: this.pagination.page,
        page_size: 20,
        search: this.search,
        status: 'draft',
        climbing: false
      })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    fetchItemsReverted() {
      getProductStorageTransfers({
        page: this.pagination_reverted.page,
        page_size: 20,
        search: this.search,
        status: 'reverted',
        climbing: false
      })
        .then(response => {
          this.table_reverted.items = response.data.results
          this.pagination_reverted.pages = response.data.pages
          this.pagination_reverted.count = response.data.count
          this.table_reverted_preloader = false
        })
    },
    onTransferSearch() {
      this.searchTransfer(this)
    },
    searchTransfer: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
      vm.fetchItemsReverted()
    }, 350),
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const data = { ...this.form }
      data.responsible_center = data.responsible_center.code
      if (this.taken_by_type === 'employee') {
        data.mountain_crew = null
        data.employee = data.some_employee.id
      } else {
        data.employee = null
        data.mountain_crew = data.some_employee.id
      }
      if (this.is_product_storage_storekeeper) data.storekeeper = this.$store.state.userData.employee.id
      postProductStorageTransfer(data)
        .then(response => {
          this.$notify({
            type: 'success',
            title: 'Transfer created',
          })
          this.$router.push({ name: 'product-storage-transfer-detail', params: { id: response.data.id } })
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
  }
}
</script>
